export const messageListSelector = (state) => state.message.messageList;
export const statusSelector = (state) => state.message.opStatus;
export const userList = (state)=> state.message.user;
